/**
 * A custom element that displays content based on authentication state.
 *
 * @example
 * ```html
 * <tbw-auth-state>
 *   <div slot="premium">
 *     <tbw-signout-btn></tbw-signout-btn>
 *   </div>
 *   <div slot="free">
 *     <tbw-signin></tbw-signin>
 *   </div>
 * </tbw-auth-state>
 * ```
 */

import { LitElement, html, css } from 'lit'
import type { AuthService } from '../services/auth.service'
// import { authService } from '../services/auth.service'

export class AuthState extends LitElement {

  constructor(private authService: AuthService = window.tbwServices.authService) { super(); }

  connectedCallback() {
    super.connectedCallback()
    document.addEventListener('authChange', this.handleAuthChange)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    document.removeEventListener('authChange', this.handleAuthChange)
  }

  private handleAuthChange = (_: Event): void => {
    this.render()
  }

  private getUserAccessSlotName() {
    let slot = "free"
    if (this.authService.isPremium) { slot = "premium" }
    // else if (authService.isFreemium) { slot = "free" }
    // else if (authService.isCorporate) { slot = "corporate" } 
    console.log(`slot ${slot}`)
    return slot
  }

  render() {
    return html`<slot name="${this.getUserAccessSlotName()}"> </slot>`
  }

  static styles = css`
    ::slotted([hidden]) {
      display: none !important;
    }
  `
}
